module.exports = __webpack_public_path__ + "static/media/handshake.3a1bd7b0.svg";